var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 17h40v16H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.074a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h21v-34H4Zm2.825 18.732c-1.333-.77-1.333-2.694 0-3.464l9.046-5.222c1.333-.77 3 .192 3 1.732v10.445c0 1.54-1.667 2.501-3 1.732l-9.046-5.223Z",
    fill: "#FBB945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 8.074H25v34h21a4 4 0 0 0 4-4v-26a4 4 0 0 0-4-4Zm-2.826 18.732c1.334-.77 1.334-2.694 0-3.464L34.13 18.12c-1.333-.77-3 .192-3 1.732v10.445c0 1.54 1.667 2.501 3 1.732l9.045-5.223Z",
    fill: "#1AD3BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.095C23 4.938 23.895 4 25 4s2 .938 2 2.095v37.81C27 45.062 26.105 46 25 46s-2-.938-2-2.095V6.095Z",
    fill: "#985184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/Planning.9e926bceed873c345ff7c2eb89c0bea1.svg";
export { ForwardRef as ReactComponent };